
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import GrandOpening from './components/GrandOpening';
import About from './components/About';
import Products from './components/Products';
import Shipping from './components/Shipping';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useSEO, generateLocalBusinessSchema, generateWebSiteSchema, generateOrganizationSchema } from '@/utils/seo';

export default function HomePage() {
  // SEO Configuration
  useSEO({
    title: 'Indianápolis Productos Mexicanos Hondureños Salvadoreños Nicaragüenses | Tienda La Bonita Market',
    description: 'Tienda La Bonita Market en Indianápolis ofrece productos mexicanos, hondureños, salvadoreños y nicaragüenses auténticos. Abarrotes, dulces, salsas, envíos con Paquetería Hernández a México, Guatemala, El Salvador y Honduras. Mejores precios y atención cercana.',
    keywords: 'tienda mexicana Indianápolis, productos mexicanos, productos hondureños, productos salvadoreños, productos nicaragüenses, abarrotes latinos Indianápolis',
    canonical: '/',
    ogType: 'website',
    ogImage: 'https://public.readdy.ai/ai/img_res/75650fcad725dd7f256cd46c3cfa8cf1.jpg',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebSiteSchema(),
        generateOrganizationSchema(),
        generateLocalBusinessSchema(),
      ],
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <GrandOpening />
        <About />
        <Products />
        <Shipping />
        <WhyChooseUs />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
